import Marquee from "react-fast-marquee";

const SLOGANS = ["POGO BILL", "WOMEN POWER", "PROTECT GOAN LAND", "SCRAP SECTION 39A", "NO DEFECTION", "YOUTH POWER", "SUSTAINABLE GOA"];

export const Ticker = () => (
  <div className="bg-[#121217] border-y border-yellow-400/20 py-5" data-testid="marquee-ticker">
    <Marquee speed={32} autoFill gradient={false}>
      {SLOGANS.map((s) => (
        <span key={s} className="flex items-center">
          <span className="mx-10 font-display font-bold uppercase text-2xl tracking-[0.08em] text-white/90">
            {s}
          </span>
          <span className="text-yellow-400 text-lg select-none">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
